import { FilterDocument, FilterOptionKeys, TaskType } from '@griply/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Repeat } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import {
  PopupMenu,
  PopupMenuList,
  PopupMenuListItem,
  PopupMenuToggle,
} from 'shared/components/ui/popup-menu';

export type CompletedContextMenuProps = {
  referenceElement?: React.RefObject<HTMLButtonElement>;
  onClose: () => void;
  filterDocument: FilterDocument;
  setFilterDocument: React.Dispatch<React.SetStateAction<FilterDocument>>;
};

export const CompletedContextMenu: React.FC<CompletedContextMenuProps> = ({
  referenceElement,
  onClose,
  filterDocument,
  setFilterDocument,
}) => {
  const { t } = useTranslation();

  const isShowingHabits =
    !filterDocument.filters?.[FilterOptionKeys.Type]?.include ||
    filterDocument.filters?.[FilterOptionKeys.Type]?.include?.includes(
      TaskType.Habit,
    );

  const toggleShowHabits = () => {
    setFilterDocument((prev) => {
      const currentFilters = prev.filters || {};
      const currentTypeFilter = currentFilters[FilterOptionKeys.Type] || {};

      // If currently showing habits, we want to hide them -> include only Task and Repeating
      if (isShowingHabits) {
        return {
          ...prev,
          filters: {
            ...currentFilters,
            [FilterOptionKeys.Type]: {
              ...currentTypeFilter,
              include: [TaskType.Task, TaskType.Repeating],
            },
          },
        };
      }

      // If currently hiding habits, we want to show them -> remove type filter or include all
      // Removing type filter is cleaner if we want to show all
      const { [FilterOptionKeys.Type]: _, ...otherFilters } = currentFilters;
      return {
        ...prev,
        filters: otherFilters,
      };
    });
  };

  return (
    <PopupMenu
      referenceElement={referenceElement}
      position="bottom-end"
      onOutside={onClose}
    >
      <PopupMenuList hasBottomBorder>
        <PopupMenuListItem>
          <PopupMenuToggle
            start={<Icon icon={Repeat} />}
            label={t('pages.today.show-habits.label')} // Reuse today's label or find appropriate key
            onChange={toggleShowHabits}
            checked={!!isShowingHabits}
          />
        </PopupMenuListItem>
      </PopupMenuList>
    </PopupMenu>
  );
};
